import { Action, createReducer, on } from '@ngrx/store';
import { DynamicRoutingStatistics } from '../../dynamic-routing.model';
import {
  clearDynamicRoutingStatisticsAction,
  setDynamicRoutingStatisticsAction,
} from './dynamic-routing-statistics.action';

const initialState: DynamicRoutingStatistics = {
  neighbors: [],
  protocols: [],
  learned_routes: [],
};

const reducer = createReducer(
  initialState,
  on(setDynamicRoutingStatisticsAction, (state, props) => ({
    ...state,
    ...props.dynamic_routing_statistics,
  })),
  on(clearDynamicRoutingStatisticsAction, () => initialState)
);

export function dynamicRoutingStatisticsReducer(
  state: DynamicRoutingStatistics | undefined,
  action: Action
) {
  return reducer(state, action);
}
